import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson29: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson28"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Cardio</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson30"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            When aiming for body recomposition, our objective is to
            simultaneously build muscle and reduce fat. Muscle growth primarily
            relies on progressive resistance training and sufficient protein
            consumption. Fat loss, on the other hand, is achieved by creating a
            caloric deficit. This deficit can be established by reducing calorie
            intake, increasing physical activity (including cardio), or a
            combination of both.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            While traditional weight-loss programs often emphasize cardio to
            create a caloric deficit, our focus here is on body recomposition
            rather than solely fat loss. Therefore, we recommend implementing
            moderate caloric deficits (up to 20 percent) even when fat loss is
            the primary goal.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Furthermore, it's important to consider the potential impact of
            cardio on resistance training adaptations. To preserve muscle mass,
            we suggest keeping cardio to a minimum while pursuing body
            recomposition. If cardio is used as a fat loss tool, it should be
            performed in a way that minimizes muscle loss.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The combination of resistance training and endurance exercise is
            known as concurrent training in scientific literature. Whether
            concurrent training negatively affects your progress depends on
            three main factors: frequency, intensity, and modality.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Frequency</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Studies indicate that, all else being equal, increased cardio
                activity has a higher likelihood of interfering with muscle
                building potential. This interference could be attributed to
                molecular-level mechanisms or simply spreading recovery
                resources too thin. While the impact varies for each individual,
                our general recommendation is to limit formal cardio sessions to
                around five sessions per week. Those with significant weight to
                lose or less active lifestyles may lean towards the higher end
                of this range, while leaner individuals or those with more
                active lifestyles may opt for the lower end.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In essence, the majority of your training focus should be
                directed towards weight training, as it is the primary driver of
                muscle growth. For fat loss goals, dietary measures should be
                prioritized over excessive reliance on cardio. In Table below
                provides specific examples to assist you in determining the
                appropriate frequency of cardio sessions.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Intensity</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Studies have indicated that higher intensity cardio,
                particularly when performed frequently, is more likely to hinder
                muscle building goals. In bodybuilding coaching circles, cardio
                is typically divided into two categories based on intensity: Low
                Intensity Steady State (LISS) and High Intensity Interval
                Training (HIIT). An example of HIIT would involve repeated
                20-second all-out sprints on a stationary bike with intervals of
                light cycling at a low intensity lasting 10-20 minutes. LISS, on
                the other hand, involves activities like walking on an incline
                treadmill for 30 minutes at a moderate pace. Each approach has
                its advantages and disadvantages.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                HIIT is often praised for its purported superior fat-burning
                effects, attributed to the increased calorie burn post-workout
                known as the EPOC (Excess Post-exercise Oxygen Consumption)
                effect. However, research suggests that the actual calorie
                expenditure from EPOC after a HIIT session is relatively modest.
                Furthermore, recent reviews indicate that the benefits of HIIT
                may be short-lived, with any potential fat loss advantage
                diminishing within a short time frame.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The main advantages of HIIT are its time efficiency and
                potential for greater engagement. However, it can be harder to
                recover from compared to low-intensity sessions, potentially
                interfering with resistance training. Additionally, if you
                already engage in intense weight training, which targets similar
                systems and adaptations, HIIT may be redundant.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                LISS, in contrast, is easier to recover from and less likely to
                interfere with muscle building. However, it may be perceived as
                more monotonous and less time-efficient.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Considering these factors, we recommend limiting HIIT cardio to
                one or two sessions per week. If further caloric deficit is
                required for fat loss, it can be achieved through reduced food
                intake or steady-state cardio.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Modality</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Scientific studies commonly indicate that cardio exercises with
                higher impact, such as running on pavement, are more prone to
                impede muscle building goals . Comparatively, activities like
                cycling or swimming involve lower impact on your musculoskeletal
                and nervous systems. While there are various cardio routines
                available, including running, cycling, swimming, hiking, and
                rollerblading, we suggest prioritizing modalities that minimize
                impact in order to minimize any potential interference with
                weight training.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Lifestyle Factors</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Considering that your main objective is fat loss, it's essential
                to take into account your lifestyle and daily activity levels
                when determining the optimal amount and type of cardio for you.
                If you lead a sedentary lifestyle, spending most of your day
                seated due to your job, incorporating some cardio into your
                daily routine can enhance your overall health, reduce stress,
                and complement your dietary efforts. Conversely, if you have a
                physically demanding job with high non-exercise activity
                thermogenesis (NEAT), such as being a construction worker or
                landscaper, additional cardio may be unnecessary and could
                potentially hinder your muscle building goals.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Activity Trackers</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                In the modern era, we are fortunate to have an array of tools
                that enable us to monitor our daily activity levels. From
                smartwatches to cell phones, there are numerous devices
                available that can provide a certain degree of quantification
                for our physical activity. Utilizing these tools can be
                advantageous in tracking and maintaining a minimum level of
                daily activity. For instance, if your lifestyle is predominantly
                sedentary and you typically average around 3,000 steps per day,
                you can easily elevate your activity level by aiming for 8,000
                steps per day.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, it is important to bear in mind that while these tools
                can be helpful for setting goals and tracking changes in
                activity, they do come with a notable margin of error,
                particularly when estimating calorie expenditure. Additionally,
                relying too heavily on these tools can lead to the development
                of obsessive habits associated with compulsively monitoring
                energy output and activity levels. Therefore, we recommend
                either setting a weekly time goal for cardio, such as two
                30-minute low-intensity steady state (LISS) sessions per week,
                or establishing a rough daily step goal, such as 8,000 steps per
                day.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As you can observe, the amount of cardio you engage in will
                require careful adjustment to align with your specific needs and
                objectives. In general, when aiming for body recomposition, it
                is crucial to take the concept of an "effective minimum" to
                heart and refer to the provided examples to determine the most
                suitable approach for you.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[88.75rem] object-cover"
          alt=""
          src="/93@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>When should you do cardio ?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Now that you grasp the concept that cardio is simply a tool to
                help you achieve the appropriate energy balance for your goals,
                you might be wondering about the timing of your cardio sessions.
                Should you do it before or after your workout? Does fasted
                cardio enhance fat loss?
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Extensive scientific evidence suggests that the timing of
                cardiovascular exercise throughout the day does not
                significantly affect your overall body composition or fat loss
                outcomes. Bearing this in mind, we recommend that you schedule
                your cardio sessions whenever it best suits your daily routine
                or at a time that allows you to consistently follow the
                protocol. This could be as straightforward as committing to
                taking the stairs instead of the elevator in your apartment
                building (if it aligns with your needs), or engaging in 30
                minutes of cycling after every leg day.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, we generally advise against performing cardio
                immediately before weight training. It is advisable to include a
                short 5-10 minute warm-up, but engaging in long or intense
                cardio sessions beforehand can deplete your energy reserves that
                are necessary for lifting weights with the appropriate intensity
                and volume. Remember, when it comes to training, the priority
                should be given to building muscle.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It is worth mentioning that while fasted cardio may not offer
                any additional benefits in terms of overall fat loss, it may
                have specific applications when dealing with so-called "stubborn
                fat." Nonetheless, fasted cardio has not been shown to have any
                significant drawbacks either. Therefore, if you find that
                engaging in cardio on an empty stomach in the morning energizes
                you for the day and you enjoy it, there is no issue with
                incorporating fasted cardio into your routine.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>CARDIO: PUTTING IT ALL TOGETHER</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 block text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <i className="font-bold">
                  Your cardio plan should be tailored to your specific needs and
                  goals
                </i>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <i className="font-bold">{`In general, we recommend keeping cardio to an effective minimum for fat loss `}</i>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <i className="font-bold">{`Low intensity steady state (LISS) cardio can be performed for up to 30-45 minutes 0-5x per week (depending on your lifestyle and primary goal) `}</i>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <i className="font-bold">{`High intensity interval training (HIIT) should be used more sparingly at a maximum of 1-2 sessions per week `}</i>
              </span>
            </li>
            <li>
              <span>
                <i className="font-bold">
                  Individuals with low levels of NEAT and fat loss goals can set
                  a ballpark step goal to increase daily activity levels (for
                  ex. ~8,000 steps per day)
                </i>
              </span>
            </li>
          </ul>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson30"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson29;
